import { render, staticRenderFns } from "./DeleteInspectionTask.vue?vue&type=template&id=46ff2646"
import script from "./DeleteInspectionTask.vue?vue&type=script&lang=js"
export * from "./DeleteInspectionTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports